const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20curated%20content%20spotlight%20with%20warm%20golden%20lighting%2C%20sophisticated%20editorial%20design%2C%20premium%20showcase%20aesthetic%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20artistic%20visual%20storytelling&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '本期焦点',
    title: '探花大神夏日合集特辑：七月最全内容盘点',
    desc: '本月探花一区与探花91社区联合企划，完整收录多位探花大神的最新力作与经典回顾，探花精选编辑团队倾力推荐。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Artistic%20content%20spotlight%20display%20with%20warm%20coral%20and%20amber%20tones%2C%20editorial%20photography%2C%20sophisticated%20layout%2C%20soft%20lighting%2C%20clean%20minimal%20background%2C%20premium%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '编辑精选',
    title: '探花一区「新锐创作者」专题推荐',
    desc: '发掘探花一区近期涌现的优秀新创作者，聚焦探花精品内容生态的新生力量，为探花迷带来更多元的浏览选择。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20digital%20content%20collection%20showcase%2C%20warm%20golden%20and%20amber%20lighting%2C%20editorial%20design%2C%20clean%20composition%2C%20premium%20visual%20aesthetic%2C%20artistic%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '社区热榜',
    title: '探花91社区月度口碑榜单：探花迷票选TOP10',
    desc: '由探花91社区用户投票产生的月度口碑榜单，汇集本周期最具人气的探花大神作品与探花精选内容。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Elegant%20premium%20content%20showcase%20with%20warm%20lighting%2C%20sophisticated%20editorial%20style%2C%20soft%20natural%20illumination%2C%20clean%20minimal%20background%2C%20artistic%20composition%2C%20refined%20aesthetic&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '经典回顾',
    title: '九一探花传奇系列回顾：不可错过的经典合集',
    desc: '重温九一探花社区历史上最具影响力的经典系列，从探花大神成名作到探花一区里程碑式内容，一次完整回顾。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-focus-3-line"></i>
            专题策划
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            探花系列平台精心策划的深度内容专题
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group relative rounded-2xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-flex px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-[10px] font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-background-50 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80 line-clamp-2 max-w-lg">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}